import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

interface IArrowWrapperProps {
  isLeft: boolean;
  arrowMarginFromTop?: string;
}

export const ArrowWrapper = styled.div<IArrowWrapperProps>`
  position: absolute;
  top: ${({ arrowMarginFromTop = '50%' }) => arrowMarginFromTop};
  display: none;
  transform: translate(0, -50%);
  cursor: pointer;
  color: transparent;
  border: none;
  outline: 0;
  z-index: 2;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.15);
  background-color: ${theme.color.background.primary};
  width: 3.25em;
  height: 3.25em;
  border-radius: 50%;

  left: ${({ isLeft }) => (isLeft ? '0.09375em' : 'initial')};
  right: ${({ isLeft }) => (isLeft ? 'initial' : '0.09375em')};

  @media (min-width: ${breakpoints.md}) {
    display: flex;
  }

  svg {
    margin: auto;
  }

  &:hover {
    background-color: #f7f7f7;
  }
`;
